import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import banner from '../../assets/images/otrlogo.png';

/**
 * Verified component
 * @author Jeremiah Liscum
 */
export default function RateVerification() {
    const [verified, setVerified] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const [searchParams] = useSearchParams();
    const guid = searchParams.get('guid');


    useEffect(() => {
    const invoicesBaseUrl = process.env.REACT_APP_INVOICES_APIM_BASE_URL;
    const acknowledgementUrl = new URL('broker-acknowledgement', invoicesBaseUrl as string);
    if (!guid) {
        setErrorMessage('No GUID provided in the URL.');
        setError(true);
        setLoading(false);
        return;
    }

    fetch(acknowledgementUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUBSCRIPTION_KEY_VALUE as string
        },
        body: JSON.stringify({ guid })
    })
        .then(async response => {
            if (!response.ok) {
                const data = await response.json();
                const parsedError = data?.errors?.[0] || 'Verification failed';
                throw new Error(parsedError);
            }
            return response.json();
        })
        .then(() => setVerified(true))
        .catch(err => {
            console.log(err.message)
            setErrorMessage("Failed to verify the GUID. Please check the link or contact support.");
            setError(true);
        })
        .finally(() => setLoading(false));
}, [guid]);


    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
                <p className="text-lg text-gray-600 dark:text-gray-300">Checking verification status...</p>
            </div>
        );
    }

    if (verified) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
                <div className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-10 w-9/10 sm:w-3/4 lg:w-1/2 max-w-2xl text-center">
                    <img src={banner} alt="OTR Banner" className="mx-auto mb-6 w-80 rounded" />
                    <h2 className="text-3xl font-semibold text-gray-700 dark:text-gray-200">Thanks for Confirming!</h2>
                    <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
                        By verifying through the link, routine verification communication becomes minimal and efficient!
                    </p>
                    <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">
                        In the event an issue arises after verification, please reply-all to the initial verification email or call us at:
                    </p>
                    <p className="mt-2 text-lg font-medium text-gray-700 dark:text-gray-400">
                        <a href="tel:7708820124" className="no-underline text-inherit">770-882-0124</a>
                    </p>
                </div>
            </div>
        );
    }
    if (error) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: '#f3f4f6',
                padding: '1.5rem',
            }}
        >
            <div
                style={{
                    backgroundColor: '#ffffff',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    borderRadius: '1rem',
                    padding: '2.5rem',
                    width: '90%',
                    maxWidth: '42rem',
                    textAlign: 'center',
                }}
            >
                <h2
                    style={{
                        fontSize: '1.5rem',
                        fontWeight: 600,
                        color: 'black',
                        marginBottom: '1rem',
                    }}
                >
                    Verification Failed
                </h2>

                <p
                    style={{
                        fontSize: '1.125rem',
                        color: '#374151',
                        marginBottom: '1rem',
                    }}
                >
                    {errorMessage}
                </p>
            </div>
        </div>
    );
}
    return null;
}
